var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 324,
    viewBox: "0 0 373 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.778 128.993L186.499 106.676L142.22 128.993L186.499 151.515L230.778 128.993Z",
    fill: "#2E4D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.197 174.272C164.186 189.725 162.864 205.165 161.34 220.518C160.773 228.111 160.023 235.671 157.819 242.988C155.452 251.599 152.309 257.966 143.71 263.739L142.035 263.573C138.381 259.709 136.557 255.478 135.588 250.808C134.362 242.777 135.904 235.028 138.003 227.372C143.14 212.441 149.035 197.546 157.384 183.921C159.489 180.486 161.902 177.097 164.684 174.055L165.197 174.272Z",
    fill: "url(#paint0_linear_540_8301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0679 234.71C63.1572 218.414 77.5888 201.151 88.6202 190.297C100.4 178.895 113.367 167.208 129.635 162.242L129.892 162.645C119.211 174.557 110.749 187.224 102.372 200.471C98.5112 206.938 94.5719 213.716 89.8893 219.648C84.9461 226.473 79.001 232.346 70.408 235.298C70.408 235.299 69.0679 234.71 69.0679 234.71Z",
    fill: "url(#paint1_linear_540_8301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.735 191.915C28.2561 174.573 46.9332 158.853 61.2594 151.552C63.8774 150.087 67.3886 148.631 70.1087 147.319C79.9886 143.155 90.5441 140.38 101.3 139.539C104.353 139.401 107.819 139.244 110.85 139.289C110.851 139.289 110.932 139.687 110.932 139.687C107.734 141.277 104.302 142.79 101.04 144.203C91.6845 148.861 82.4924 153.674 74.1767 159.879C67.0202 164.994 59.4644 172.601 52.9071 178.467C47.0075 184.083 40.8994 189.274 32.8832 192.421L31.735 191.915Z",
    fill: "url(#paint2_linear_540_8301)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.879 117.676C55.3143 125.54 49.123 136.333 30.7533 141.786L30 141.234C30.5846 132.832 37.1054 126.807 44.1132 122.887C54.1972 117.062 66.0651 115.419 77.5436 114.624C85.0328 114.145 92.5343 114.38 99.9514 115.322C103.64 115.795 107.308 116.408 110.903 117.373L110.879 117.676Z",
    fill: "url(#paint3_linear_540_8301)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.309 96.506C125.932 94.8078 115.583 93.4026 105.199 93.5103C97.3898 93.5913 78.0116 95.3406 74.6736 94.5903L74.343 93.9565C83.321 79.5772 108.296 84.4942 121.843 89.237C126.955 91.1006 131.917 93.3083 136.407 96.2896L136.309 96.506Z",
    fill: "url(#paint4_linear_540_8301)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.16 83.2179C165.604 80.1501 161.157 77.08 156.264 74.7901C151.166 72.3982 146.45 71.6945 142.238 67.712C142.238 67.7109 142.221 67.2059 142.221 67.2059C144.869 64.6453 148.35 64.673 151.604 65.4966C157.528 67.1859 162.078 71.4947 165.847 75.9012C167.629 78.1344 169.221 80.4919 170.3 83.1158L170.16 83.2179Z",
    fill: "url(#paint5_linear_540_8301)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.802 174.272C208.814 189.725 210.135 205.165 211.659 220.518C212.226 228.111 212.976 235.671 215.181 242.988C217.548 251.599 220.691 257.966 229.289 263.739L230.964 263.573C234.619 259.709 236.442 255.478 237.412 250.808C238.638 242.777 237.096 235.028 234.997 227.372C229.86 212.441 223.964 197.546 215.615 183.921C213.511 180.486 211.098 177.097 208.316 174.055L207.802 174.272Z",
    fill: "url(#paint6_linear_540_8301)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.933 234.71C309.844 218.414 295.413 201.151 284.381 190.297C272.6 178.895 259.634 167.208 243.366 162.242L243.109 162.645C253.79 174.557 262.252 187.224 270.629 200.471C274.49 206.938 278.429 213.716 283.112 219.648C288.055 226.473 294 232.346 302.593 235.298C302.593 235.299 303.933 234.71 303.933 234.71Z",
    fill: "url(#paint7_linear_540_8301)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.265 191.915C344.744 174.573 326.067 158.853 311.741 151.552C309.123 150.087 305.612 148.631 302.891 147.319C293.012 143.155 282.456 140.38 271.7 139.539C268.647 139.401 265.181 139.244 262.15 139.289C262.149 139.289 262.068 139.687 262.068 139.687C265.266 141.277 268.698 142.79 271.96 144.203C281.316 148.861 290.508 153.674 298.823 159.879C305.98 164.994 313.536 172.601 320.093 178.467C325.993 184.083 332.101 189.274 340.117 192.421L341.265 191.915Z",
    fill: "url(#paint8_linear_540_8301)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.122 117.676C317.686 125.54 323.877 136.333 342.247 141.786L343 141.234C342.415 132.832 335.895 126.807 328.887 122.887C318.803 117.062 306.935 115.419 295.457 114.624C287.967 114.145 280.466 114.38 273.049 115.322C269.36 115.795 265.693 116.408 262.097 117.373L262.122 117.676Z",
    fill: "url(#paint9_linear_540_8301)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236.69 96.506C247.067 94.8078 257.416 93.4026 267.801 93.5103C275.61 93.5913 294.987 95.3406 298.326 94.5903L298.657 93.9565C289.679 79.5772 264.704 84.4942 251.156 89.237C246.044 91.1006 241.082 93.3083 236.593 96.2896L236.69 96.506Z",
    fill: "url(#paint10_linear_540_8301)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.839 83.2179C207.395 80.1501 211.843 77.08 216.735 74.7901C221.833 72.3982 226.549 71.6945 230.761 67.712L230.778 67.2059C228.13 64.6453 224.649 64.673 221.395 65.4966C215.471 67.1859 210.922 71.4947 207.152 75.9012C205.371 78.1344 203.779 80.4919 202.699 83.1158L202.839 83.2179Z",
    fill: "url(#paint11_linear_540_8301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_540_8301",
    x1: 150.175,
    y1: 42.2328,
    x2: 150.175,
    y2: 149.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_540_8301",
    x1: 98.7937,
    y1: 42.2082,
    x2: 98.7937,
    y2: 149.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_540_8301",
    x1: 71.1216,
    y1: 42.2159,
    x2: 71.1216,
    y2: 149.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_540_8301",
    x1: 70.4515,
    y1: 42.2369,
    x2: 70.4515,
    y2: 149.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_540_8301",
    x1: 105.375,
    y1: 42.2241,
    x2: 105.375,
    y2: 149.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_540_8301",
    x1: 156.261,
    y1: 42.2236,
    x2: 156.261,
    y2: 149.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_540_8301",
    x1: 222.825,
    y1: 42.2328,
    x2: 222.825,
    y2: 149.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_540_8301",
    x1: 274.207,
    y1: 42.2082,
    x2: 274.207,
    y2: 149.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_540_8301",
    x1: 301.878,
    y1: 42.2159,
    x2: 301.878,
    y2: 149.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_540_8301",
    x1: 302.549,
    y1: 42.2369,
    x2: 302.549,
    y2: 149.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_540_8301",
    x1: 267.625,
    y1: 42.2241,
    x2: 267.625,
    y2: 149.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_540_8301",
    x1: 216.739,
    y1: 42.2236,
    x2: 216.739,
    y2: 149.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#9D6636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE8848"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ad5c1c7ccada71e654a20faf795e0d42.svg";
export { ForwardRef as ReactComponent };